import Model from 'models/model';
import App from 'models/app';

const serializeApp = ({ id, name, requiresSync, requiresWifi }) => ({
  id,
  name,
  requiresSync,
  requiresWifi
});

export default class InstallFlow extends Model {
  constructor(...args) {
    super(...args);

    this.createGetters(['currentlySyncing', 'requiresWifi', 'apps']);
  }

  static selectFromState(state) {
    const { currentlySyncing, syncMode } = state.gallery;

    const { installedApps } = state.registry;

    const { continueInstall } = state.installFlow;

    let requiresSync = false;
    let requiresWifi = false;
    const apps = {};
    for (const appId in installedApps) {
      const app = App.selectFromState(appId, state);
      if (!app) {
        continue;
      }
      if (app.requiresSync) {
        requiresSync = true;
        if (app.requiresWifi) {
          requiresWifi = true;
        }
      }
      apps[appId] = serializeApp(app);
    }

    return new InstallFlow({
      currentlySyncing,
      syncMode,
      requiresSync,
      requiresWifi,
      apps,
      continueInstall
    });
  }

  get continueInstall() {
    const requiresSync = this._get('requiresSync');
    const continueInstall = this._get('continueInstall') || {};

    if (requiresSync === continueInstall.show) {
      return continueInstall;
    }

    return {
      ...continueInstall,
      show: requiresSync
    };
  }

  get requiresSync() {
    const requiresSync = this._get('requiresSync');
    const { shouldContinue } = this._get('continueInstall') || {};

    if (!requiresSync) {
      return false;
    }

    if (shouldContinue) {
      return true;
    }

    return false;
  }

  toState() {
    return {
      continueInstall: this.continueInstall,
      currentlySyncing: this.currentlySyncing,
      requiresSync: this.requiresSync,
      requiresWifi: this.requiresWifi,
      apps: this.apps
    };
  }

  isDifferent({
    currentlySyncing,
    requiresSync,
    requiresWifi,
    continueInstall
  } = {}) {
    return (
      (!this.currentlySyncing && this.requiresSync) ||
      this.currentlySyncing !== currentlySyncing ||
      this.requiresSync !== requiresSync ||
      this.requiresWifi !== requiresWifi ||
      this.continueInstall !== continueInstall
    );
  }
}
